import { ethers } from 'ethers';
import { API, Auth } from "aws-amplify";
import amplify from '../amplify.json';
import { getContracts } from '../lib/contracts';

const INFURA_RPC = process.env.REACT_APP_INFURA_URL || '';

class APIUtils {

    async getDappData() {
        try {
            if (!INFURA_RPC) throw new Error('MethaCrowdsale address not set');
            const provider = new ethers.providers.JsonRpcProvider(INFURA_RPC);
            const { crowdsale, token } = getContracts(provider);

            const [currentPeriod, weiRaised, remainingPeriodTime, tokenSupply] =
                await Promise.all([
                    crowdsale.getCurrentPeriod(),
                    crowdsale.getWeiRaised(),
                    crowdsale.getRemainingPeriodTime(),
                    token.totalSupply(),
                ]);

            const periodRaisedRaw = await crowdsale.getWeiRaisedPerPeriod(Number(currentPeriod));

            const toEth = (bn) => parseFloat(ethers.utils.formatEther(bn));

            const remainingSecs = Number(remainingPeriodTime);

            console.log('[getDappData] fetched at', new Date().toISOString(),
                '| remainingPeriodTime (raw):', remainingPeriodTime.toString(),
                '| remainingSecs:', remainingSecs,
                '| current_period:', Number(currentPeriod));

            return {
                current_period: Number(currentPeriod),
                wei_raised: toEth(weiRaised),
                token_supply: toEth(tokenSupply),
                periodRaised: toEth(periodRaisedRaw),
                remaining_period_time: remainingSecs,
            };
        } catch (e) {
            console.error('getDappData error:', e);
            return {
                current_period: 0,
                wei_raised: 0,
                token_supply: 0,
                periodRaised: 0,
                remaining_period_time: 0,
            };
        }
    }

    getTransactions(pagination, lastPeriod, lastIndex) {
        return new Promise((resolve, reject) => {
            API.get(amplify.API.endpoints[0].name, "/dapp/fetchTransactions", {
                queryStringParameters: {
                    pagination, lastPeriod, lastIndex
                }
            })
                .then(result => resolve(result))
                .catch(err => {
                    console.log(err);
                    reject(err);
                });
        });
    }

    async getUserData() {
        const headers = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` };
        return new Promise((resolve, reject) => {
            API.get(amplify.API.endpoints[0].name, "/user/get", {
                headers,
                queryStringParameters: {}
            })
                .then(result => resolve(result))
                .catch(err => {
                    console.log(err);
                    reject(err);
                });
        });
    }

    async updateUserWallet(wallet) {
        const headers = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` };
        return new Promise((resolve, reject) => {
            API.post(amplify.API.endpoints[0].name, "/user/updatewallet", {
                headers,
                body: { wallet }
            })
                .then(result => resolve(result))
                .catch(err => reject(err));
        });
    }

    async userCheckContribution() {
        const headers = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` };
        return new Promise((resolve, reject) => {
            API.post(amplify.API.endpoints[0].name, "/user/checkcontribution", {
                headers
            })
                .then(result => resolve(result))
                .catch(err => reject(err));
        });
    }

}

const apiUtils = new APIUtils();
export default apiUtils;
